export const initHomepageProfileResearchOptIn = () => {
  const dialogResearchOptIn = document.getElementById(
    "dialog-research-opt-in",
  ) as HTMLDialogElement;

  if (!dialogResearchOptIn) {
    return;
  }

  const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");

  const closeDialogButtons: NodeListOf<HTMLButtonElement> =
    dialogResearchOptIn.querySelectorAll(".close-dialog");

  closeDialogButtons.forEach((closeDialogButton) => {
    closeDialogButton.addEventListener("click", () => {
      // biome-ignore lint/suspicious/noDocumentCookie: <Refactor later>
      document.cookie =
        "research_opt_in=false; max-age=2592000; path=/; domain=" +
        hostnameBase +
        "; secure; samesite=lax";
    });
  });
};
